module.exports = __webpack_public_path__ + "9a5eeab4c590c91fa0602425d1299ea2.fbx";